const FormResources = {

    form_data:{
        building_id:        '',
        level_id:           '',
        area_id:            '',
        task_id:            '',
        room_type_id:       '',
        floor_id:           '',
        cost_center_id:     '',
        closed:               '',
        essential_cleaning: '',
        policing:           false,
        project:            false,
        patient:            '',
        exclude_daily:      '',
        work_group:         '',
        exclude_project:    '',
        shift1:             '',
        shift2:             '',
        shift3:             '',
        unassigned_rooms:   false,
        freq_simbol:        1,
        frequency:          '',
    },

    form_format:[
    ],

    week_form_data: {
        sunday:     false,
        monday:     false,
        tuesday:    false,
        wednesday:  false,
        thursday:   false,
        friday:     false,
        saturday:   false,
    },

}

export default FormResources